import React from 'react';

import { MailableTable } from '@/components/postgrid/postgrid-mailables/mailable-table/MailableTable';
import { Heading } from '@/components/ui/catalyst/heading';
import { Text } from '@/components/ui/catalyst/text';

const ChequesPage: React.FC = () => {
  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="border-b border-zinc-200 p-6">
        <div>
          <Heading level={1}>All Cheques</Heading>
          <Text className="text-zinc-600 mt-1">
            View all cheques across all matters. Use the Type filter to show
            only cheques.
          </Text>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 p-6">
        <MailableTable />
      </div>
    </div>
  );
};

export default ChequesPage;
